import type { ProductListItem } from "@/client/types.gen";
import "./ProductCard.css";

export default function ProductCard(product?: ProductListItem) {
  if (!product) {
    return <div className="product-card" />;
  }

  return (
    <a href={product.url} target="_blank" className="product-card-link">
      <div className="product-card">
        {product.primary_image_url && (
          <img
            src={product.primary_image_url}
            alt={product.title}
            className="product-card-image"
          />
        )}
        <div className="product-card-content">
          <p className="product-card-brand">{product.brand_name}</p>
          <h3 className="product-card-title">{product.title}</h3>
          <p className="product-card-site">{product.site_display_name}</p>
          <div className="product-card-price">
            <span className="product-card-current-price">{product.currency}{product.price}</span>
            {product.original_price && (
              <span className="product-card-original-price">
                {product.original_price}
              </span>
            )}
          </div>
          {!product.is_available && (
            <span className="product-card-unavailable">Not Available</span>
          )}
        </div>
      </div>
    </a>
  );
}
